<template>
<div class="chapter">
<div class="inner_page">
<div class="img_containerr1"><a id="page_7"></a><img alt="images" src="images/f0007-01.jpg"/>
<p class="cap">Map of Carmarthen to Fishguard Harbour. <span class="font1">(Richard Harman)</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Fm01.vue?30a27e0b